import React from "react";

const Tools = () => (
  <div>
    <h1 className="title is-1" style={{color: 'black'}}>Tools</h1>
    <p style={{color: 'black'}}>
    <ul style={{listStyleType: 'square'}}>
        <li> JavaScript </li>
        <li> React </li>
        <li> Express.js </li>
        <li> Node.js </li>
        <li> Visual Studio </li>
        <li> Git </li>
    </ul>
    </p>
    <br></br>
    <br></br>
  </div>
);

export default Tools;

{/*      */}